<template>
    <div>
        <top :id="'new'"></top>
        <banner :url="url"></banner>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
            <tit></tit>
            <div class="goods" v-for="(item,index) in newlLIst1" :key="index">
                <div class="goods1 F-flex">
                    <img :src="item.image" alt="" class="goods1-img" />
                    <div
                        style="width:400px;height:448px"
                        class="flex flex-column jus-between"
                    >
                        <div class="goods-title">
                            {{ item.title }}
                        </div>
                        <div class="goods-subtitle">
                            {{ item.subtitle }}
                        </div>
                        <div class="line"></div>
                        <div style="font-size: 34px;color: #FF6701;">
                            活动价：¥
                            <span style="font-size: 60px;">{{
                                item.price
                            }}</span>
                        </div>
                        <div class="btn" @click="resultBtn(item.id)">
                            立即购买
                        </div>
                    </div>
                </div>
            </div>

            <div class="goods F-flex">
                <div class="goods2" v-for="(item,index) in newlLIst2" :key="index">
                    <img :src="item.image"  @click="resultBtn(item.id)" alt="" />
                    <div class="goods2-con">
                        <div class="f24 orange">{{ item.title }}</div>
                        <div class="f18">{{ item.subtitle }}</div>
                        <div class="f18">
                            活动价：¥ <span class="f32">{{ item.price }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <el-carousel
                    height="420px"
                    direction="vertical"
                    :autoplay="false"
                >
                    <el-carousel-item v-for="(item,index) in NewProduct2" :key="(index)">
                        <img :src="item.image" alt="" @click="newProductBnt(item.url)" />
                    </el-carousel-item>
                </el-carousel>
            </div>

            <div class="goods-box flex flex-wrap ">
                 <div class="goods-item" v-for="(item,index) in newlLIst3" :key="index">
                        <img
                            :src="item.image"
                            alt=""
                            class="goods-img"
                        />
                        <div class="goods-name flex ali-cen">
                            <div class="goods-tag">修复</div>
                            <div class="goods-name-text">
                                {{item.title}}
                            </div>
                        </div>
                        <div class="goods-text">
                           {{item.subtitle}}
                        </div>
                        <div class="goods-price F-flex">
                            <div style="color: #FF6701;font-size: 14px;">
                                ¥{{item.price}}
                            </div>
                            <div class="goods-btn" @click="resultBtn(item.id)">立即购买</div>
                        </div>
                    </div>
            </div>
              <div class="" style="" v-for="(item,index) in newList4" :key="index">
                  <div style="margin-bottom:15px;color: #606266">
                     {{item.title}}
                  </div>
                  <div style="display:flex;">
                       <div class="goods-item" style="margin-right: 11px;" v-for="item in item.goodsList.data" :key="item.id">
                     
                        <img
                            :src="item.image"
                            alt=""
                            class="goods-img"
                        />
                        <div class="goods-name flex ali-cen">
                            <div class="goods-tag">修复</div>
                            <div class="goods-name-text">
                                {{item.title}}
                            </div>
                        </div>
                        <div class="goods-text">
                           {{item.subtitle}}
                        </div>
                        <div class="goods-price F-flex">
                            <div style="color: #FF6701;font-size: 14px;">
                                ¥{{item.price}}
                            </div>
                            <div class="goods-btn" @click="resultBtn(item.id)">立即购买</div>
                        </div>
                    </div>
                  </div>
                
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import banner from "../../components/banner.vue";
import tit from "../../components/title.vue";

import { newProduct, banners_pc } from "@/api/index.js";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        return {
            url: [{ name: "新品发布", url: "/new" }],
            NewProduct2: [],
            newlLIst1: [],
            newlLIst2: [],
            newlLIst3: [],
            newList4:[]
        };
    },
    beforeCreate() {
        document
            .querySelector("body")
            .setAttribute("style", "background:#f5f5f5");
    },
    created() {
        this.newProductReleast();
        this.getNewList2();
    },
    methods: {
        //新品发布
        newProductReleast() {
            newProduct({ activity: "new_product", type: "ing" }, header).then(
                res => {
                    if (res.code !== 1) {
                        return;
                    }
                    console.log('res.data.data',res);
                    this.newlLIst1 = res.data[0].goodsList.data.slice(0, 2);
                    this.newlLIst2 = res.data[0].goodsList.data.slice(2, 4);
                    this.newlLIst3 = res.data[0].goodsList.data.slice(4);
                    let sxlist = res.data.slice(1)
                    let arr = []
                    sxlist.forEach(item => {
                        console.log('item',item)
                        this.newList4.push(item)
                        // item.goodsList.data.forEach(item1=>{
                         
                        //     arr.push(item1)
                           
                        
                        // })
                    });
                    // console.log(arr)
                    // this.newList4 = arr
                    //  console.log(this.newList4)
                   
                }
            );
        },
        getNewList2() {
            banners_pc({ status: "NewProduct2" }).then(res => {
                this.NewProduct2 = res.data.lists;
                // console.log(this.NewProduct2);
            });
        },
        resultBtn(item){
        console.log(item)
        this.$router.push({path:'/info',query:{id:item}})
        },
        newProductBnt(url){
             if(url == ''){
            return
            }
            window.open(url);
        }
    },
    components: {
        top,
        breadcrumb,
        bottom,
        banner,
        tit
    }
};
</script>
<style scoped lang="less">
.goods {
    width: 100%;
    height: 516px;
    background: #ffffff;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 28px;
}
.btn {
    width: 290px;
    height: 84px;
    background: #ff6701;
    border-radius: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 38px;
    color: #fff;
    cursor: pointer;
}
.goods1 {
    .goods1-img {
        width: 648px;
        height: 448px;
        border-radius: 48px;
    }
    .goods-title {
        font-size: 38px;
        color: #ff6701;
        line-height: 38px;
    }
    .goods-subtitle {
        font-size: 32px;
    }
}
.goods2 {
    width: 458px;
    cursor: pointer;
    img {
        width: 458px;
        height: 361px;
        border-radius: 30px;
    }

    .goods2-con {
        div {
            line-height: 30px;
            text-align: center;
        }
    }
}
.goods-box {
    .goods-item {
        margin-right: 11px;
        &:nth-child(5n + 5) {
            margin-right: 0;
        }
    }
}
.el-carousel__item {
    img {
        border-radius: 20px;
        width: 100%;
    }
}
.goods-item {
    width: 231px;
    height: 301px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    padding: 10px;
    margin-bottom: 14px;
    .goods-img {
        width: 207px;
        height: 200px;
        margin-bottom: 10px;
    }
    .goods-name {
        font-size: 16px;
        .goods-tag {
            width: 43px;
            height: 15px;
            background: #5db031;
            border-radius: 10px;
            text-align: center;
            font-size: 10px;
            line-height: 15px;
            color: #fff;
        }
        .goods-name-text {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 166px;
        }
    }
    .goods-text {
        font-size: 12px;
        margin: 5px 0;
            overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
    }
    .goods-btn {
        width: 70px;
        height: 22px;
        background: #ff6701;
        text-align: center;
        line-height: 22px;
        color: #fff;
        font-size: 12px;
        border-radius: 11px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/new.vue